import React from 'react';
import PropTypes from 'prop-types';

const POIRating = (props) => {

  return (
    <div className="sk-hits-list-hit__rating">
      <div className="sk-hits-list-hit__rating-top">
        <div className="emoji">
          <div className="emoji-item">
            <i className="happy" />
            <div className="emoji__count">{props._source.positive_ratings_count}</div>
          </div>
          <div className="emoji-item">
            <i className="neutral" />
            <div className="emoji__count">{props._source.neutral_ratings_count}</div>
          </div>
          <div className="emoji-item">
            <i className="sad" />
            <div className="emoji__count">{props._source.negative_ratings_count}</div>
          </div>
        </div>
      </div>
      <div className="info">Rating</div>
    </div>
  );
};

POIRating.propTypes = {
  _source: PropTypes.shape({
    positive_ratings_count: PropTypes.number,
    neutral_ratings_count: PropTypes.number,
    negative_ratings_count: PropTypes.number
  })
};

export default POIRating;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/POIListItems/POIRating.jsx